export const LanguageToIso: Map<string, string> = new Map([
  ["ca", "AD"],
  ["en", "GB"],
  ["sq", "AL"],
  ["hy", "AM"],
  ["de", "DE"],
  ["az", "AZ"],
  ["bs", "BA"],
  ["bn", "BD"],
  ["bg", "BG"],
  ["ms", "BN"],
  ["be", "BY"],
  ["zh", "CN"],
  ["cs", "CZ"],
  ["da", "DK"],
  ["et", "EE"],
  ["aa", "ER"],
  ["es", "ES"],
  ["am", "ET"],
  ["fi", "FI"],
  ["fo", "FO"],
  ["fr", "FR"],
  ["ka", "GE"],
  ["kl", "GL"],
  ["el", "GR"],
  ["hr", "HR"],
  ["ht", "HT"],
  ["hu", "HU"],
  ["id", "ID"],
  ["he", "IL"],
  ["is", "IS"],
  ["it", "IT"],
  ["ja", "JP"],
  ["ky", "KG"],
  ["km", "KH"],
  ["ko", "KR"],
  ["kk", "KZ"],
  ["lo", "LA"],
  ["si", "LK"],
  ["lt", "LT"],
  ["lb", "LU"],
  ["lv", "LV"],
  ["mh", "MH"],
  ["mk", "MK"],
  ["my", "MM"],
  ["mn", "MN"],
  ["mt", "MT"],
  ["dv", "MV"],
  ["ny", "MW"],
  ["ms", "MY"],
  ["nl", "NL"],
  ["no", "NO"],
  ["ne", "NP"],
  ["na", "NR"],
  ["tl", "PH"],
  ["ur", "PK"],
  ["pl", "PL"],
  ["pt", "PT"],
  ["ro", "RO"],
  ["sr", "RS"],
  ["ru", "RU"],
  ["rw", "RW"],
  ["sv", "SE"],
  ["sl", "SI"],
  ["sk", "SK"],
  ["so", "SO"],
  ["th", "TH"],
  ["tg", "TJ"],
  ["tk", "TM"],
  ["to", "TO"],
  ["tr", "TR"],
  ["sw", "TZ"],
  ["uk", "UA"],
  ["uz", "UZ"],
  ["la", "VA"],
  ["vi", "VN"],
  ["bi", "VU"],
  ["sm", "WS"],
  ["cu", "CS"],
])
